"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icons = require("@jsluna/icons");

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _utils = require("@jsluna/utils");

var _excluded = ["getInputProps", "getToggleButtonProps", "getClearButtonProps", "selectedOption", "selectedOptions", "isOpen", "placeholder", "describedBy", "onChange", "getOptionLabel", "getOptionValue", "icon", "action", "hideInput", "autoComplete", "disabled", "spellcheck", "name"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var AutocompleteInputGroup = function AutocompleteInputGroup(_ref) {
  var getInputProps = _ref.getInputProps,
      getToggleButtonProps = _ref.getToggleButtonProps,
      getClearButtonProps = _ref.getClearButtonProps,
      selectedOption = _ref.selectedOption,
      selectedOptions = _ref.selectedOptions,
      isOpen = _ref.isOpen,
      placeholder = _ref.placeholder,
      describedBy = _ref.describedBy,
      onChange = _ref.onChange,
      getOptionLabel = _ref.getOptionLabel,
      getOptionValue = _ref.getOptionValue,
      icon = _ref.icon,
      action = _ref.action,
      hideInput = _ref.hideInput,
      autoComplete = _ref.autoComplete,
      disabled = _ref.disabled,
      spellcheck = _ref.spellcheck,
      name = _ref.name,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var selectedOptionsLength = selectedOptions.length;
  var isMultiple = selectedOptionsLength > 0;
  var clearButtonProps = getClearButtonProps();

  var handleBackspace = function handleBackspace(e) {
    if (e.target.value.length > 0 && !selectedOption) {
      return true;
    }

    if (isMultiple) {
      return clearButtonProps.onClick(selectedOptions[selectedOptionsLength - 1]);
    }

    return clearButtonProps.onClick();
  };

  var inputProps = getInputProps({
    onChange: onChange,
    onKeyDown: (0, _utils.onKeyPress)([{
      name: 'Backspace',
      code: 8
    }], handleBackspace),
    role: 'textbox',
    disabled: disabled
  });
  return /*#__PURE__*/_react.default.createElement(_form.InputGroup, {
    disabled: disabled
  }, icon && /*#__PURE__*/_react.default.createElement(_form.InputIcon, null, icon), /*#__PURE__*/_react.default.createElement(_form.InputControl, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('ln-c-autocomplete', isOpen && 'is-open')
  }, isMultiple && selectedOptions.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: getOptionValue(item),
      className: "ln-c-autocomplete__selected-item"
    }, getOptionLabel(item), /*#__PURE__*/_react.default.createElement("button", _extends({
      type: "button",
      className: "ln-c-autocomplete__clear-selected-item"
    }, clearButtonProps, {
      onClick: function onClick() {
        return clearButtonProps.onClick(item);
      }
    }), /*#__PURE__*/_react.default.createElement(_icons.Cancel, {
      fixed: true
    })));
  }), !hideInput && /*#__PURE__*/_react.default.createElement(_form.Input, _extends({}, rest, {
    className: "ln-c-autocomplete__input"
  }, inputProps, {
    value: !isMultiple && selectedOption ? getOptionLabel(selectedOption) : inputProps.value,
    placeholder: placeholder,
    "aria-describedby": describedBy,
    autoComplete: autoComplete,
    spellCheck: spellcheck,
    id: name,
    name: name
  })))), (!hideInput && action || selectedOption) && /*#__PURE__*/_react.default.createElement(_form.InputAction, null, selectedOption ? /*#__PURE__*/_react.default.createElement(_button.Button, clearButtonProps, /*#__PURE__*/_react.default.createElement(_icons.Cancel, null)) : action && /*#__PURE__*/_react.default.createElement(_button.Button, getToggleButtonProps({
    disabled: disabled
  }), isOpen ? /*#__PURE__*/_react.default.createElement(_icons.ArrowUp, null) : /*#__PURE__*/_react.default.createElement(_icons.ArrowDown, null))));
};

AutocompleteInputGroup.propTypes = {
  getInputProps: _propTypes.default.func.isRequired,
  getToggleButtonProps: _propTypes.default.func.isRequired,
  getClearButtonProps: _propTypes.default.func.isRequired,
  selectedOption: _propTypes.default.shape({}),
  selectedOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  isOpen: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  describedBy: _propTypes.default.string,
  onChange: _propTypes.default.func,
  getOptionLabel: _propTypes.default.func.isRequired,
  getOptionValue: _propTypes.default.func.isRequired,
  icon: _propTypes.default.node,
  action: _propTypes.default.bool,
  hideInput: _propTypes.default.bool,
  autoComplete: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  spellcheck: _propTypes.default.bool,
  name: _propTypes.default.string
};
AutocompleteInputGroup.defaultProps = {
  selectedOption: undefined,
  selectedOptions: [],
  isOpen: false,
  placeholder: undefined,
  describedBy: undefined,
  onChange: undefined,
  icon: undefined,
  action: true,
  hideInput: false,
  autoComplete: 'off',
  disabled: false,
  spellcheck: false,
  name: undefined
};
AutocompleteInputGroup.displayName = 'AutocompleteInputGroup';
var _default = AutocompleteInputGroup;
exports.default = _default;